"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSchemaV2 = exports.ContactSchema = void 0;
const yup = __importStar(require("yup"));
const User_1 = require("./User");
exports.ContactSchema = {
    salutation: yup.string().trim().oneOf([null, "", "Mr", "Mrs", "Miss", "Ms", "Dr"]).nullable(),
    familyName: User_1.UserSchema.familyName,
    firstName: User_1.UserSchema.firstName,
    secondName: User_1.UserSchema.secondName,
    thirdName: User_1.UserSchema.thirdName,
    email: yup.string().email("Email must be a valid email").required("Please enter the email").max(255),
    iso2Code: yup
        .string()
        .required("Please enter the iso2 code")
        .matches(/^[A-Z]{2}$/, "Invalid iso2 code"),
    dialCode: yup
        .string()
        .required("Please enter the dial code")
        .matches(/^\+[1-9]\d{0,3}$/, "Invalid dial code"),
    phoneNumber: yup
        .string()
        .trim()
        .required("Please enter the phone number")
        .matches(/^\d{1,14}$/, "Phone Number can only contain digits, at most 14 digits are allowed"),
};
exports.ContactSchemaV2 = {
    _id: yup.string(),
    firstName: yup.lazy(() => yup
        .string()
        .trim()
        .when(["familyName", "email", "phoneNumber"], (familyName, email, phoneNumber) => familyName || email || phoneNumber ? yup.string().required("Please enter the First name") : yup.string())),
    familyName: yup.lazy(() => yup
        .string()
        .trim()
        .when(["firstName", "email", "phoneNumber"], (firstName, email, phoneNumber) => firstName || email || phoneNumber ? yup.string().required("Please enter the Last name") : yup.string())),
    email: yup.lazy((value) => (!value ? yup.string() : yup.string().email("Email must be a valid email").max(255))),
    iso2Code: yup.string().trim(),
    dialCode: yup.string().trim(),
    phoneNumber: yup
        .string()
        .trim()
        .max(14, "Phone Numbers must be at most 14 digits")
        .matches(/^[0-9]*$/, {
        excludeEmptyString: true,
        message: "Phone Numbers can only contain digits",
    }),
};
//# sourceMappingURL=Contact.js.map